<template>
  <div id="details-app-page" class="main-page">
    <div class="container" v-if="complete">
      <p class="app-page-title">Summary</p>

      <div class="app-section">
        <p class="app-section-title">User</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">User Information</td>
            </tr>
            <tr>
              <td>Full name</td>
              <td>{{detail.fullname}}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{detail.app_user}}</td>
            </tr>
            <tr>
              <td>Application type</td>
              <td>{{detail.app_name}}</td>
            </tr>
            <tr>
              <td>Application ID</td>
              <td>{{detail.uid}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Business</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Company Details</td>
            </tr>
            <tr>
              <td>Legal Name</td>
              <td>{{detail.company.legal_company_name || '-'}}</td>
            </tr>
            <tr>
              <td>Registered DBA/Trade Name</td>
              <td>{{detail.company.dba || '-'}}</td>
            </tr>
            <tr>
              <td>Incorporation Date</td>
              <td>{{detail.company.company_start_date || '-'}}</td>
            </tr>
            <tr>
              <td>Registered Street Address</td>
              <td>{{detail.company.company_address || '-'}}</td>
            </tr>
            <tr>
              <td>City</td>
              <td>{{detail.company.company_city || '-'}}</td>
            </tr>
            <tr>
              <td>State</td>
              <td>{{detail.company.company_state_name || '-'}}</td>
            </tr>
            <tr>
              <td>Zip / Postal Code</td>
              <td>{{detail.company.company_zip_portal || '-'}}</td>
            </tr>
            <tr>
              <td>Country of Incorporation</td>
              <td>{{detail.company.company_country_name || '-'}}</td>
            </tr>
            <tr>
              <td>Phone Number</td>
              <td>{{detail.company.company_phone || '-'}}</td>
            </tr>
            <tr>
              <td>Company Email</td>
              <td>{{detail.company.company_email || '-'}}</td>
            </tr>
            <tr>
              <td>Website URL</td>
              <td>{{detail.company.company_web || '-'}}</td>
            </tr>
            <tr>
              <td>VAT/Tax Identification Number</td>
              <td>{{detail.company.tax_id || '-'}}</td>
            </tr>
            <tr>
              <td>Business License Number</td>
              <td>{{detail.company.company_license_number || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Directors</td>
            </tr>
            <tr>
              <td>First Name</td>
              <td>{{detail.director.first_name || '-'}}</td>
            </tr>
            <tr>
              <td>Last Name</td>
              <td>{{detail.director.last_name || '-'}}</td>
            </tr>
            <tr>
              <td>Title</td>
              <td>{{detail.director.title || '-'}}</td>
            </tr>
            <tr>
              <td>Second Director First Name (If Required)</td>
              <td>{{detail.director.second_director_first_name || '-'}}</td>
            </tr>
            <tr>
              <td>Second Director Last Name (If Required)</td>
              <td>{{detail.director.second_director_last_name || '-'}}</td>
            </tr>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Contacts</td>
            </tr>
            <tr>
              <td>Main Contact Name</td>
              <td>{{detail.contact.main_contact || '-'}}</td>
            </tr>
            <tr>
              <td>Main Contact Email</td>
              <td>{{detail.contact.accounting_contact_email || '-'}}</td>
            </tr>
            <tr>
              <td>Accounting Contact Name (If Different)</td>
              <td>{{detail.contact.accounting_contact_name || '-'}}</td>
            </tr>
            <tr>
              <td>Accounting Contact Email (If Different)</td>
              <td>{{detail.contact.accounting_contact_email || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Billing Info</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Credit Card Information (Billing)</td>
            </tr>
            <tr>
              <td>Name On Card</td>
              <td>{{detail.card.card_name || '-'}}</td>
            </tr>
            <tr>
              <td>Billing Address</td>
              <td>{{detail.card.billing_address || '-'}}</td>
            </tr>
            <tr>
              <td>Billing contact Number</td>
              <td>{{detail.card.billing_contact_number || '-'}}</td>
            </tr>
            <tr>
              <td>Billing Contact Email</td>
              <td>{{detail.card.billing_contact_email || '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="app-section">
        <p class="app-section-title">Documentation</p>
        <table class="table details-table">
          <tbody>
            <tr class="details-section-row">
              <td class="details-section" colspan="2">Supporting Documents</td>
            </tr>
            <tr>
              <td>Drivers License</td>
              <td>
                <a
                  v-if="detail.document_driver_license"
                  :href="detail.document_driver_license"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Voided Check</td>
              <td>
                <a
                  v-if="detail.document_Voided_Check"
                  :href="detail.document_Voided_Check"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>Articles of Incorporation</td>
              <td>
                <a
                  v-if="detail.document_Articles_of_Incorporation"
                  :href="detail.document_Articles_of_Incorporation"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Bank Statements</td>
              <td>
                <a
                  v-if="detail.document_Months_of_Bank_Statements"
                  :href="detail.document_Months_of_Bank_Statements"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
            <tr>
              <td>(4) Months of Processing Statements</td>
              <td>
                <a
                  v-if="detail.document_Months_of_Processing_Statements"
                  :href="detail.document_Months_of_Processing_Statements"
                  class="view-document"
                  target="_blank"
                >
                  <i class="fas fa-external-link-alt"></i> View document
                </a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["param"],
  data: () => {
    return {
      detail: [],
      complete: false
    };
  },
  mounted() {
    this.$store
      .dispatch("get_app_detail", this.param)
      .then(res => {
        this.detail = res.data;
        this.complete = true;
      })
      .catch(err => {});
  }
};
</script>

<style>
</style>